import {
  BarChart3,
  Calendar,
  Clock,
  CreditCard,
  DollarSign,
  Heart,
  MessageSquare,
  Shield,
  Smartphone,
  Star,
  TrendingUp,
  Users,
  Zap,
} from "lucide-react";

export const stats = [
  { icon: TrendingUp, stat: "40%", label: "Average Revenue Increase" },
  { icon: Clock, stat: "15hrs", label: "Saved Per Week" },
  { icon: Star, stat: "4.9/5", label: "Customer Rating" },
  { icon: Users, stat: "2,500+", label: "Happy Salon Owners" },
];

export const platformFeatures = [
  {
    title: "Beautiful Calendar View",
    description:
      "See your entire day at a glance. Drag, drop, and manage appointments effortlessly.",
  },
  {
    title: "Powerful Reports Dashboard",
    description:
      "Track revenue, staff performance, and business trends in real-time.",
  },
  {
    title: "Smart Client Management",
    description:
      "Keep detailed profiles, service history, and preferences for every client.",
  },
  {
    title: "Integrated POS System",
    description:
      "Accept payments instantly with card, cash, or gift cards — all in one place.",
  },
  {
    title: "Inventory Management",
    description:
      "Track products, monitor stock levels, and get low-inventory alerts automatically.",
  },
];

export const problemItems = [
  { problem: "No-shows costing you", amount: "$800/month" },
  { problem: "Time wasted on scheduling", amount: "$1,200/month" },
  { problem: "Missed upsell opportunities", amount: "$700/month" },
  { problem: "Manual commission calculations", amount: "$300/month" },
];

export const solutionItems = [
  { solution: "Automated reminders eliminate no-shows", saved: "+$800/month" },
  { solution: "24/7 online booking fills your schedule", saved: "+$1,200/month" },
  { solution: "Smart product recommendations", saved: "+$700/month" },
  { solution: "Instant commission tracking", saved: "+$300/month" },
];

export const features = [
  { icon: Calendar, title: "24/7 Online Booking", description: "Clients book while you sleep. Never miss a booking again." },
  { icon: MessageSquare, title: "Smart Reminders", description: "Automated texts reduce no-shows by 87%. Seriously." },
  { icon: CreditCard, title: "Built-In Payments", description: "Accept cards, cash, gift cards. Get paid faster." },
  { icon: Users, title: "Client Profiles", description: "Remember preferences, history, and allergies automatically." },
  { icon: BarChart3, title: "Real-Time Analytics", description: "Know exactly how your business is performing—always." },
  { icon: DollarSign, title: "Commission Tracking", description: "Calculate staff pay in seconds, not hours." },
  { icon: Smartphone, title: "Mobile Friendly", description: "Manage your business from anywhere, anytime." },
  { icon: Shield, title: "Data Security", description: "Bank-level encryption. Your data is safer than Fort Knox." },
  { icon: Heart, title: "Support", description: "Real humans, real help, real fast. 5-minute response time." },
];

export const howItWorks = [
  {
    step: "1",
    title: "Sign Up & Import",
    description: "Add services, staff, and existing clients in minutes.",
    icon: Users,
  },
  {
    step: "2",
    title: "Customize & Launch",
    description: "Set your hours, pricing, and booking preferences.",
    icon: Zap,
  },
  {
    step: "3",
    title: "Grow & Profit",
    description: "Watch bookings roll in while you manage everything from one place.",
    icon: TrendingUp,
  },
];

export const pricingFeatures = [
  "Unlimited staff members",
  "Unlimited appointments",
  "24/7 online booking page",
  "Automated text reminders",
  "Advanced reports & analytics",
  "Inventory management",
  "Commission tracking",
  "Mobile app included",
  "Integrated payment processing",
  "Priority support (5 min response)",
  "Free data migration",
  "Free training for your team",
];